<div id="map" class="map"></div>
<div id="menu">
    <mat-radio-group (change)="onMapStyleSelectChange($event)">
        <mat-radio-button [value]="mapStyleOutdors" [checked]="true">{{'map_style_outdoors' | translate}}</mat-radio-button>
        <mat-radio-button [value]="mapStyleSatellite">{{'map_style_satelite' | translate}}</mat-radio-button>
    </mat-radio-group>    
</div>
<div [hidden]="true">
    <canvas *ngFor="let iconName of defaultSpeciesIcons" [hidden]="true" [id]="iconName" width="48" height="48">Canvas not supported</canvas>
    <canvas *ngFor="let iconName of defaultPoiIcons" [hidden]="true" [id]="iconName" width="48" height="48">Canvas not supported</canvas>
</div>